import React, { useState } from 'react';
import {Breadcrumb, Col, Row} from 'antd';
import './MainLayout.css';
import logo from '../../Assests/assets/images/GLSR Logo_white/GLSR Logo_white.png';
import webinarPic from '../../Assests/assets/images/Picture01/Picture01.png';
import featIcon from '../../Assests/assets/images/Icon_Book.svg';
import WebinarListItem from '../WebinarListItem/WebinarListItem';

const MainLayout = (props) => {
  const webinar_name = "T.Y.B.COM Semester - 6";

  return (
    <div class='main-layout'>
      <div class='breadcrumb-div'>
        <Breadcrumb>
          <Breadcrumb.Item className="breadcrumb-text">
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item className="breadcrumb-text">
            <a href="">Webinars</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item className="breadcrumb-text">
            {webinar_name}
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Row className='first-row'>
        <Col xs={24} sm={24} md = {24} lg = {24}>
          <Row>
            <Col md={8}>
              <div class='webinar-pic-left-container'>
                <img src={webinarPic} class='webinar-pic'/>
              </div>
            </Col>
            <Col md={16}>
              <div class='webinar-main-info'>
                <span class='degree'>
                  B.COM
                </span>
                <div class='webinar-main-content'>
                  <div class='webinar-title'>
                    {webinar_name}
                  </div>
                  <div class='webinar-main-content-text'>
                    Complete guide for excelling in your final 
                    semester university exams, it is going to 
                    be a journey of 4 weeks in which you will be 
                    revising each and every topic of your all major 
                    subjects, it is designed completely by university
                    ’s expert professors for you so just enrol and 
                    excel in your exams.
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className='second-row'>
        <Col xs={24} sm={24} md = {24} lg = {24}>
          <Row>
            <Col xs={24} sm = {24} md={8}>
              <div class='webinar-bottom-left'>
                <div class='hide-shadow'>
                </div>
                <div class='webinar-board-div'>
                  <div class="amount-title">
                  Buy Entire Package for
                  </div>
                  <div class='webinar-amt'>
                    ₹ 199
                  </div>
                  <button class='webinar-buy-btn-container'>
                    <span class='webinar-buy-btn-text'>
                      Buy Now
                    </span>
                  </button>
                </div>
                <div class='webinar-features'>
                  <span class='webinar-features-title'>
                    Features
                  </span>
                </div>
                <div class='webinar-features-list-container'>
                  <div class='webinar-features-list-item'>
                    <span class='webinar-features-list-item-icon'>
                      <img src={featIcon} />
                    </span>
                    <span class='webinar-features-list-item-text'>
                      Full portion covered
                    </span>
                  </div>
                  <div class='webinar-features-list-item'>
                    <span class='webinar-features-list-item-icon'>
                      <img src={featIcon} />
                    </span>
                    <span class='webinar-features-list-item-text'>
                      Time Bound Intensive Training
                    </span>
                  </div>
                  <div class='webinar-features-list-item'>
                    <span class='webinar-features-list-item-icon'>
                      <img src={featIcon} />
                    </span>
                    <span class='webinar-features-list-item-text'>
                      Most Likely question taught
                    </span>
                  </div>
                  <div class='webinar-features-list-item'>
                    <span class='webinar-features-list-item-icon'>
                      <img src={featIcon} />
                    </span>
                    <span class='webinar-features-list-item-text'>
                      Full Chapter wise revision
                    </span>
                  </div>
                  <div class='webinar-features-list-item'>
                    <span class='webinar-features-list-item-icon'>
                      <img src={featIcon} />
                    </span>
                    <span class='webinar-features-list-item-text'>
                      Interactive question and answer session
                    </span>
                  </div>
                  <div class='webinar-features-list-item'>
                    <span class='webinar-features-list-item-icon'>
                      <img src={featIcon} />
                    </span>
                    <span class='webinar-features-list-item-text'>
                      Special Revision materials provided.
                    </span>
                  </div>
                  <div class='webinar-features-list-item'>
                    <span class='webinar-features-list-item-icon'>
                      <img src={featIcon} />
                    </span>
                    <span class='webinar-features-list-item-text'>
                      Unlimited access over content
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={16}>
              <WebinarListItem name='Business Economics - 6' dateOfWebinar='Jun 21, 2020' noOfSessions='2' status='upcoming-next'/>
              <WebinarListItem name='Commerce-6' dateOfWebinar='Sept 05, 2020' noOfSessions='2' status='completed'/>
              <WebinarListItem name='Financial Accounting' dateOfWebinar='Feb 21, 2020' noOfSessions='10' status='upcoming-future'/>
              <WebinarListItem name='Cost Accounting' dateOfWebinar='Mar 14, 2020' noOfSessions='10' status='upcoming-future'/>
              <WebinarListItem name='Indirect Tax Sometimes title can be so long that we have to push it on to the next line' dateOfWebinar='Apr 05, 2020' noOfSessions='8' status='upcoming-future'/>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default MainLayout;
